import styles from './Loader.module.css'
import Icon from '../Icon'

export default function Loader() {
  return (
    <div className={styles.wrapper}>
        <div className={styles.logo_wrapper}>
            <div className={styles.logo}>
                <Icon name='loaderLogo' width='120' height='114'/>
            </div>
        </div>
        <div className={styles.text_wrapper}>
            <span className='text_captions_c2'>ВОСТОК СТРОЙ</span>
            <span className='text_captions_c2'>{new Date().getFullYear()}</span>
        </div>
    </div>
  )
}